import React, { useState, useContext, useEffect } from 'react';
import {
	Row,
	Col,
	FormGroup,
	Label,
	Card,
	CardBody,
	Form,
	Input
} from 'reactstrap';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import { Clear, CloudDownloadOutlined } from '@mui/icons-material';
import { LoaderMini } from '~/components/Loaders';

import { dataFinalAnteriorInicial } from '~/helpers/date';
import { toast } from 'react-toastify';

import ReactGA from 'react-ga4';
import { ExtratoContext } from '../../../context/ExtratoContext'

import {
	ButtonStyled,
	CheckBoxCss,
	TextClick
} from './styles';

export function FiltroExtratoCredito(props) {
	const {
		user,
		setFiltroData,
		filtroTipo,
		setFiltroTipo,
		setPagina,
		filtroData,
		filtroPesquisa,
		setFiltroPesquisa,
		revendaId,
		setRevendaId,
		page,
		filtroRevendaHierarquia,
		setFiltroRevendaHierarquia,
		showFiltrarCredDeb = true,
		children
	} = props;

	const {
		getExportExtrato,
		getExportIndustria,
		getExport,
		origemConcatenada,
	} = useContext(ExtratoContext);

	const [isMobile, setIsMobile] = useState(false);
	const [loadingDownload, setLoadingDownload] = useState(false);

	const [button, setButton] = useState({
		hoje: false,
		dias7: false,
	});

	const [dataRange, setDataRange] = useState({
		dateInit: '',
		dateEnd: '',
	});

	const [params, setParams] = useState({
		dateInit: moment().format('YYYY-MM-DD'),
		dateEnd: moment().format('YYYY-MM-DD'),
	});

	useEffect(() => {
		if (dataRange.dateEnd !== '') {
			if (dataFinalAnteriorInicial(dataRange.dateInit, dataRange.dateEnd)) {
				toast.warning('Data final não pode ser anterior a data inicial');
				setDataRange({
					dateInit: '',
					dateEnd: '',
				});
			} else {
				updateDateFilter();
				handleFiltroDataGA4();
			}
		}
	}, [dataRange]);

	function handleClickDownloadExtratoCreditoGA4() {
		ReactGA.event({
			category: "download_extrato_credito_click",
			action: "Download Extrado de Crédito",
			label: "Baixando Extrado de Crédito",
		});
	}

	function extrairData() {
		setLoadingDownload(true);
		if(!user.dados.permissoes.view_extrato_industria_ems){
			if (user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor' || user.dados.cargo.toLowerCase() === 'industria') {
				getExport(
					page,
					user.dados.documento,
					filtroData,
					filtroTipo,
					params,
					filtroRevendaHierarquia
				).then(() => setLoadingDownload(false))
			} else if (user.dados.cargo.toLowerCase() === '') {
				getExportExtrato(
					page,
					user.dados.documento,
					filtroData,
					filtroTipo,
					params,
					revendaId,
					filtroRevendaHierarquia
				).then(() => setLoadingDownload(false))
			}
		}else{
			getExportIndustria(
				filtroData,
				filtroPesquisa,
			).then(() => setLoadingDownload(false))
		}

		handleClickDownloadExtratoCreditoGA4();
	}

	function handlerFiltrarHoje() {
		setFiltroData('&hoje=true');

		setButton({
			hoje: true,
			dias7: false,
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});
		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setPagina(1);
		handleFiltroHojeGA4();
	}

	function handlerFiltrar7Dias() {
		setFiltroData('&semana=true');

		setButton({
			hoje: false,
			dias7: true,
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});
		setParams({
			dateInit: moment().subtract(7, 'days').format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});
		setPagina(1);
		handleFiltro7DiasGA4();
	}

	function updateDateFilter() {
		const paramsTemp = [
			moment(dataRange.dateInit).format('YYYY-MM-DD'),
			moment(dataRange.dateEnd).format('YYYY-MM-DD'),
		];

		setParams({
			dateInit: moment(dataRange.dateInit).format('YYYY-MM-DD'),
			dateEnd: moment(dataRange.dateEnd).format('YYYY-MM-DD'),
		});

		setButton({
			hoje: false,
			dias7: false,
		});

		setFiltroData(`&data_lancamento=${paramsTemp[0]}%7C${paramsTemp[1]}`);

		setPagina(1);
	}

	function handlerLimparFiltro() {
		setFiltroRevendaHierarquia("")
		setFiltroData('');
		setFiltroPesquisa('');

		setButton({
			hoje: false,
			dias7: false,
		});

		setDataRange({
			dateInit: '',
			dateEnd: '',
		});

		setParams({
			dateInit: moment().format('YYYY-MM-DD'),
			dateEnd: moment().format('YYYY-MM-DD'),
		});

		setPagina(1);

		setFiltroTipo({
			creditados: true,
			debitados: true,
		})
	}

	const ColData = (
		<>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data inicial"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block"
						selected={dataRange.dateInit}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateInit: value,
							})
						}
					/>
				</FormGroup>
			</Col>
			<Col style={{ padding: `${isMobile && 0}` }}>
				<FormGroup className="d-flex flex-column">
					<DatePicker
						placeholderText="Data final"
						dateFormat="dd/MM/yyyy"
						className="form-control d-block w-100"
						selected={dataRange.dateEnd}
						onChange={(value) =>
							setDataRange({
								...dataRange,
								dateEnd: value,
							})
						}
					/>
				</FormGroup>
			</Col>

		</>
	)

	const handleChangeCheckBox = (event) => {
		setFiltroTipo({ ...filtroTipo, [event.target.name]: event.target.checked });
		setPagina(1);
	}

	const handleChangeOrigem = (event) => {
		setRevendaId(event.target.value)
	}

	function handleFiltroHojeGA4() {
		ReactGA.event({
			category: "filtro_hoje_extrato_click",
			action: "Filtro Hoje extrato",
			label: "Filtrando Hoje extrato",
		});
	}

	function handleFiltro7DiasGA4() {
		ReactGA.event({
			category: "filtro_7dias_extrato_click",
			action: "Filtro 7 dias extrato",
			label: "Filtrando 7 dias extrato",
		});
	}

	function handleFiltroDataGA4() {
		ReactGA.event({
			category: "filtro_data_extrato_click",
			action: "Filtro por data extrato",
			label: "Filtrando por data extrato",
		});
	}

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 900); // Defina a largura de tela que considera como mobile
		};

		handleResize();

		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<Card
			style={{
				boxShadow: 'unset',
				borderRadius: '0px 18px 18px 18px',
			}}>
			<CardBody>
				<Row>
					<Col xs="12" md="12" lg={user.dados.cargo.toLowerCase() !== 'industria' ? 4 : 4}>
						<FormGroup>
							<Label style={{ fontWeight: 'bold' }} className="d-block">
								Filtrar por período
							</Label>
							<Row>
								<Col>
									<ButtonStyled
										className="w-100 my-0"
										disabled={button.hoje}
										onClick={() => handlerFiltrarHoje()}>
										Hoje
									</ButtonStyled>
								</Col>
								<Col>
									<ButtonStyled
										className="w-100 my-0"
										disabled={button.dias7}
										onClick={() => handlerFiltrar7Dias()}>
										7 dias
									</ButtonStyled>
								</Col>
							</Row>
						</FormGroup>
					</Col>
					<Col xs="12" md="6" lg={user.dados.cargo.toLowerCase() !== 'industria' ? 4 : 4}>
						<FormGroup>
							<Label style={{ fontWeight: 'bold' }} className="d-block">Filtrar por data</Label>
							{!isMobile ?
								<Row>
									{ColData}
								</Row> :
								<>
									{ColData}
								</>
							}
						</FormGroup>
					</Col>
					{((user.dados.cargo.toLowerCase() === 'industria' || user.dados.cargo.split(" ")[0].toLowerCase() === 'distribuidor') &&
						(user.dados.tipo_projeto.toLowerCase() === 'iquine' || user.dados.tipo_projeto.toLowerCase() === 'hidracor')) &&
						<Col sm="12" md="4" lg="2">
							<FormGroup>
								<Label className="d-block" style={{ fontWeight: 'bold' }}>
									Filtrar por Origem
								</Label>
								<Row>
									<Col>
										<FormGroup className="d-flex flex-column">
											<Input
												type="select"
												onChange={handleChangeOrigem}>
												<option value="todos">
													Todos
												</option>
												{origemConcatenada.map(
													(item) => (
														<option
															key={item.id}
															value={item.id}>
															{`#${item.id} | ${item.grupo.nome}`}
														</option>
													)
												)}
											</Input>
										</FormGroup>
									</Col>
								</Row>
							</FormGroup>
						</Col>}
					{user.dados.cargo.toLowerCase() !== 'industria' && showFiltrarCredDeb &&
						<Col xs="12" md="6" lg="2">
							<Label style={{ fontWeight: 'bold' }} className="d-block">Filtrar: </Label>
							<Form style={{ paddingLeft: 20 }}>
								<FormGroup
									inline
								>
									<CheckBoxCss onChange={handleChangeCheckBox} checked={filtroTipo.creditados} name="creditados" type="checkbox" />
									<Label style={{ fontWeight: 'bold', paddingLeft: 10 }} check>
										Creditados
									</Label>
								</FormGroup>
								<FormGroup
									inline
								>
									<CheckBoxCss onChange={handleChangeCheckBox} checked={filtroTipo.debitados} name="debitados" type="checkbox" />
									<Label style={{ fontWeight: 'bold', paddingLeft: 10 }} check>
										Debitados
									</Label>
								</FormGroup>
							</Form>
						</Col>}

					<Col xs="12" md="12" lg="9">
						{children}
					</Col>
					<Col xs="12" md="12" lg="12">
						<button
							style={{ all: 'unset', cursor: 'pointer', color: '#333333', float: 'right' }}
							type='button'
							onClick={() => handlerLimparFiltro()}>
							<Clear style={{ color: '#0AD6EA' }} />
							Limpar Filtros
						</button>
						{/* {user.dados.tipo_projeto.toLowerCase() === 'intelbras' &&
							<> */}
						<div style={{ all: 'unset', cursor: 'pointer', paddingRight: 10, color: '#333333', float: 'right' }}>
							{!loadingDownload ? (
								<TextClick
									style={{ all: 'unset', cursor: 'pointer', paddingRight: 10, color: '#333333', float: 'right' }}
									onClick={() => extrairData()}
									tabIndex="0"
									role="button"
								>
									<CloudDownloadOutlined className="mr-1" />
									Fazer Download
								</TextClick>
							) : (
								<LoaderMini />
							)}
						</div>
						{/* </>
						} */}
					</Col>

				</Row>
			</CardBody>
		</Card>
	);
}
